import styled from 'styled-components'

export const AdmStyle = styled.div`
  text-align: center;
`
